import { useState, useCallback, useMemo } from 'react';

/**
 * Bundles success/error message state and close handlers for use with PageSnackbars.
 */
export function usePageSnackbar() {
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const onCloseSuccess = useCallback(() => {
    setSuccessMessage('');
  }, []);

  const onCloseError = useCallback(() => {
    setErrorMessage('');
  }, []);

  const snackbarProps = useMemo(
    () => ({
      successMessage,
      errorMessage,
      onCloseSuccess,
      onCloseError,
    }),
    [successMessage, errorMessage, onCloseSuccess, onCloseError]
  );

  return {
    successMessage,
    errorMessage,
    setSuccessMessage,
    setErrorMessage,
    onCloseSuccess,
    onCloseError,
    snackbarProps,
  };
}
